import { GlobalState } from '../../reducers';

export const getFiles = (state: GlobalState) => state.files.normalized;
